import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';

import ImageCarousel from 'component/ImageCarousel';
import NestedPageBanner from 'component/NestedPageBanner';
import FrameL from 'component/FrameL';
import Loader from 'component/Loader';

export default ({ match }) => {
    const [ cmsData, setCmsData ] = useState(null);
    let Name = match.params.name;
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_DOMAIN}/nested-pages/${Name}`)
        .then(response => response.json())
        .then(data => {
            setCmsData(data);
        }).catch(error => {
          // @todo handle error
          console.log('Something went wrong');
        })
    }, []);
    
    if (!cmsData) {
        return <Loader></Loader>
    }

    let { NestedPage, DisplayName } = cmsData;
    Name = DisplayName || Name;
    NestedPage = NestedPage[0];
    if (NestedPage.__component === 'section.nested-page1') {        
        const { Carousel = [], LeftSide, RightSide } = NestedPage;
        return <stack-l space="var(--s4)" class="max-w-screen-lg mx-auto px-4 pb-10">
            <div className="relative break-out-banner">
                <ImageCarousel ratio="16:9">
                    {Carousel.map((Image, i) => {
                        return <FrameL ratio="16:9" Image={Image}></FrameL>
                    })}
                </ImageCarousel>
                <h1 className="page-title text-5xl text-white capitalize">{Name}</h1>
            </div>
            <grid-l min="400px" space="var(--s2)">
                <div>
                    <ReactMarkdown>{LeftSide}</ReactMarkdown>
                </div>
                <div>
                    <ReactMarkdown>{RightSide}</ReactMarkdown>
                </div>
            </grid-l>
        </stack-l>
    } else {
        const { Carousel = [], Sections = [] } = NestedPage;

        return <stack-l space="var(--s4)" class="xl:container mx-auto px-4 pb-10">
            <div className="relative break-out-banner">
                <ImageCarousel ratio="16:9">
                    {Carousel.map((Image, i) => {
                        return <FrameL ratio="16:9" Image={Image}></FrameL>
                    })}
                </ImageCarousel>
                <h1 className="page-title text-5xl text-white capitalize">{Name}</h1>
            </div>
            
            {Sections.map((Banner, i) => {
                return <NestedPageBanner key={i}  cmsData={Banner} />
            })}
        </stack-l>
    }
}